import React from 'react';

const ContentLibrary = () => {
  return (
    <div className="flex-1 flex flex-col min-h-0 bg-white p-6 items-center justify-center border border-[#E5E7EB] rounded-lg shadow-sm">
      <h2 className="text-[#171717] font-outfit text-xl font-semibold mb-2">Content Library</h2>
      <p className="text-[#52525B] font-outfit text-[14px]">Manage your saved libraries and internal knowledge base here.</p>
    </div>
  );
};

export default ContentLibrary;
